import { Grid } from "@mui/material";
import MxFormL3RushSwitchField from "@rf-l3/form/MxFormL3RushSwitchField";
import MxFormL3TextThousandField from "@rf-l3/form/MxFormL3TextThousandField";
import { A_CURRENCY } from "@/src-refactor/modules/shared/model/const/currency.conts";
import { CModalSchemaKeys } from "./BuildingUnitFormModal";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";

const Prices = () => {
  return (
    <Grid container item xs={12} spacing={1} rowGap={2}>
      <Grid item xs={12}>
        <MxFormSubTitle label="Especifica precio" />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MxFormL3RushSwitchField
          name={CModalSchemaKeys.currency}
          items={A_CURRENCY}
          withreacthookform={1}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MxFormL3TextThousandField
          label="Precio de venta"
          name={CModalSchemaKeys.price}
          withreacthookform={1}
        />
      </Grid>
    </Grid>
  );
};

export default Prices;
